// extracted by mini-css-extract-plugin
export var linkText = "_q0-0";